import { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";

import PlotFlyout from "./PlotFlyout";
import Flyout from "./Flyout";
import MapView from "./MapView";
import LoadingSpinner from "./LoadingSpinner";
import { useParameterContext } from "../types/ParameterContext";

export default function MainPanel() {
  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;

  const stopLoading = () => setLoadingCount((count) => Math.max(0, count - 1));
  const startLoading = () => setLoadingCount((count) => count + 1);

  const [selectedParameters, setSelectedParameters] = useState<string[]>([]);
  const [selectedScenarios, setSelectedScenarios] = useState<string[]>([]);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);

  const { calcDiff } = useParameterContext();

  const [mapHeight, setMapHeight] = useState(300); // default fallback


const leftFlyoutWidth = 515; // adjust as needed
const rightFlyoutWidth = 700; // adjust as needed
const [mapMaxWidth, setMapMaxWidth] = useState(300);

  const colCount = selectedScenarios.length > selectedParameters.length
    ? selectedScenarios.length
    : selectedParameters.length;
  useEffect(() => {
    const updateWidths = () => {
      const parentWidth = window.innerWidth;
      const availableWidth = parentWidth - leftFlyoutWidth - rightFlyoutWidth;
      const numCols = colCount // inside your map row rendering
      setMapMaxWidth(availableWidth / numCols);
    };
    updateWidths();
    window.addEventListener("resize", updateWidths);
    return () => window.removeEventListener("resize", updateWidths);
  }, [colCount]);

  const rowCount =
    selectedScenarios.length < selectedParameters.length
      ? selectedScenarios.length
      : selectedParameters.length;

  useEffect(() => {
    const calculateHeight = () => {
      const overhead = 200; // Adjust this based on Flyout, headers, margins
      const available = window.innerHeight - overhead;
      setMapHeight(available / rowCount);
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return () => window.removeEventListener("resize", calculateHeight);
  }, [rowCount]);

  return (
    <div className="relative min-h-screen w-full overflow-y-auto bg-gray-50">
      <Flyout
        selectedParameters={selectedParameters}
        setSelectedParameters={setSelectedParameters}
        selectedScenarios={selectedScenarios}
        setSelectedScenarios={setSelectedScenarios}
        selectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
      />
      <PlotFlyout />

      {isLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-60 flex items-center justify-center z-[1000]">
          <LoadingSpinner />
        </div>
      )}

      <div className="space-y-4 p-4">
        {(selectedScenarios.length < selectedParameters.length
          ? selectedScenarios
          : selectedParameters
        ).map((rowItem, rowIndex) => {
          const isScenarioRow = selectedScenarios.length < selectedParameters.length;
          const cols = isScenarioRow ? selectedParameters : selectedScenarios;

          return (
            <div
              key={rowIndex}
              className="flex flex-nowrap justify-center gap-4 w-full overflow-x-auto border shadow"
              // style={{marginLeft: leftFlyoutWidth}}
            >
            {/* <div key={rowIndex}> */}
              {cols.map((colItem, colIndex) => {
                const scenario = isScenarioRow ? rowItem : colItem;
                const parameter = isScenarioRow ? colItem : rowItem;

                return (
                   <div
                     key={`${scenario}-${parameter}`}
                     className="flex flex-col items-center p-2 w-full  border rounded shadow "
                     style={{ width: mapMaxWidth, maxWidth: mapMaxWidth }}
                   >
                   {/* <div key={`${scenario}-${parameter}`}> */}
                    <h2 className="text-center text-sm font-semibold mb-1">
                      Scenario: {scenario}
                    </h2>
                    <h2 className="text-center text-sm font-semibold mb-2">
                      Parameter: {parameter}{" "}
                      {calcDiff && scenario !== selectedScenarios[0] ? " (Diff)" : ""}
                    </h2>

                    <div style={{ height: mapHeight }} className="w-full">
                      <MapView
                        key={`${scenario}-${parameter}`}
                        iscenario={scenario}
                        parameter={parameter}
                        time={selectedTime}
                        startLoading={startLoading}
                        stopLoading={stopLoading}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
